import gql from 'graphql-tag';

const COMPLIANCE_AUDIENCES = gql`
  query complianceAudiences($where: AudienceWhereInput) {
    audiencesConnection(where: $where, orderBy: createdAt_DESC) {
      edges {
        node {
          id
          name
          type
          isAmplifyDefault
          createdAt
          updatedAt
          geoTargets {
            id
            name
            location {
              id
              name
              formattedAddress
              street
              state
              city
              zip
              lat
              lng
              country
              county
              licenses {
                designations
              }
            }
            polygons {
              geometry
            }
            circles {
              radius
              coordinate {
                lat
                lng
              }
              location {
                id
                name
                formattedAddress
                zip
                street
                city
                county
                state
                country
                lat
                lng
              }
            }
          }
          eventsTargets {
            id
          }
          createdBy {
            id
            name
          }
          orgs {
            id
            name
          }
        }
      }
    }
  }
`;

export default COMPLIANCE_AUDIENCES;
